module.exports = __webpack_public_path__ + "img/icon-light-text.5c31c221.svg";